'use strict';

/** @type {import('./min')} */
module.exports = Math.min;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/math-intrinsics/min.js
// module id = ../../../../math-intrinsics/min.js
// module chunks = 5